import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    
    state = {

    }

    print() {
        console.log(this.props.data.Months)
    }

    selectColor(style) {
        console.log(style)
        switch (style) {
            case 'Not Started':
                return "status-success";
            case 'In Process':
                return "status-warning";
            case 'Finished':
                return "status-danger";
            default:
                return "";
        }
    }


    render() {
        // Get request status
        const { loading, error, Title } = this.props;

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <div>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-sm-12 col-md-4 text-center mb-3'>
                            <div className='metric-card status-success'>
                                <p className='metric-label'>Not started</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.NotStarted))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-4 text-center mb-3'>
                            <div className='metric-card status-warning'>
                                <p className='metric-label'>In progress</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.InProcess))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-4 text-center mb-3'>
                            <div className='metric-card status-danger'>
                                <p className='metric-label'>Finished</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.Finished))}</div>
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-sm-6'>
                                    <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                                </div>
                                <div className='backgroundWhite col-sm-12 '>
                                    <div className='pb-3' />
                                    <div className="tableFixHeadSmall">
                                        <table className='table table-clean'>
                                            <thead>
                                                <tr>
                                                    <th>Order No</th>
                                                    <th>Type</th>
                                                    <th>Customer No</th>
                                                    <th>Customer Name</th>
                                                    <th>Date</th>
                                                    <th>Days in System</th>
                                                    <th>Picking Status</th>
                                                    <th>Sales Person</th>
                                                    <th>Have Invoice?</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.data.map((order, o) => (
                                                    <tr className={order.ColorRow} key={o}>
                                                        <td>{order.SalesOrderNo}</td>
                                                        <td>{order.TypeinLetters}</td>
                                                        <td>{order.CustomerNo}</td>
                                                        <td>{order.BillToName}</td>
                                                        <td>{order.OrderDate}</td>
                                                        <td className='text-center'>{order.DaysSystem}</td>
                                                        <td className={this.selectColor(order.StatusColor)}>{order.StatusText}</td>
                                                        <td className='text-center'>{order.SalespersonNo}</td>
                                                        <td className='text-center'>{order.ExistInv}</td>

                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
